import { schema } from "normalizr";

const fzArtSchema = new schema.Entity("fzart", {}, { idAttribute: "id" });

export { fzArtSchema };
